<template>
    <picture class="picture" :class="{ 'out-of-stock': outOfStockGreyedOut }">
        <template v-if="imageBySize?.imageCdn120">
            <source ref="source" media="(min-width:576px)" :srcset="imageBySize.imageCdn320 + ' 1x'" />
            <img :srcset="imageBySize.imageCdn240 + ' 1x'" :alt="imageAlt" :loading="lazyImage ? 'lazy' : 'eager'" @error="setAltImg" />
        </template>
        <template v-else>
            <img :src="imageUrl" :alt="imageAlt" :loading="lazyImage ? 'lazy' : 'eager'" @error="setAltImg" />
        </template>
    </picture>
</template>

<script lang="ts">
import { PropType } from 'vue'
import ImageBySize from '~/models/ImageBySize'

export default {
    props: {
        imageAlt: {
            type: String,
            default: 'Product image',
        },
        outOfStockGreyedOut: {
            type: Boolean,
            default: false,
        },
        lazyImage: {
            type: Boolean,
            default: true,
        },
        imageUrl: {
            type: String,
            default: '',
        },
        imageBySize: {
            type: Object as PropType<ImageBySize | null>,
            default: () => null,
        },
    },

    methods: {
        setAltImg(event: Event) {
            if (this.$refs.source) {
                this.$refs.source.srcset = '/nuxt-assets/images/lazy-load-error.svg'
            }
            const eventTarget = event.target as HTMLImageElement
            eventTarget.src = '/nuxt-assets/images/lazy-load-error.svg'
            eventTarget.srcset = '/nuxt-assets/images/lazy-load-error.svg'
        },
    },
}
</script>
<style lang="scss" scoped>
.picture {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        max-width: 100%;
        max-height: 100%;
        height: auto;
        width: auto;
    }
}

.out-of-stock {
    filter: grayscale(1);
}
</style>
